"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var is_after_1 = tslib_1.__importDefault(require("date-fns/is_after"));
var parse_1 = tslib_1.__importDefault(require("date-fns/parse"));
var difference_in_minutes_1 = tslib_1.__importDefault(require("date-fns/difference_in_minutes"));
var contests_constants_1 = require("@biw/contests-constants");
var get = require("lodash/get");
var selectorRoleRegex = new RegExp("^" + contests_constants_1.ROLE__SELECTOR + "$", 'i');
/**
 * daysToDate will calculate a number of given days until the date
 * If the date is in the past it will return 0
 * If the date is < than 1 day but > 1 minute in the future, it will be rounded up to 1 day
 * @param dateTo Any date-like object (e.g. Numrical unix timestamp, ISO timestamp, or fully instantiated Date object)
 * @param startDate [now] Any date-like object (e.g. Numrical unix timestamp, ISO timestamp, or fully instantiated Date object)
 */
var daysToDate = function (dateTo, startDate) {
    if (startDate === void 0) { startDate = new Date(); }
    return Math.max(0, Math.ceil(difference_in_minutes_1.default(parse_1.default(dateTo), parse_1.default(startDate)) / 1440));
};
var HAS_PROGRESS = [contests_constants_1.PVS__PROGRESS_LOADED_NO_ISSUANCE, contests_constants_1.PVS__FINAL_ISSUANCE];
var ProgramModel = /** @class */ (function () {
    function ProgramModel(contest) {
        this.__state = contest || {};
        this.__proxyRef = {};
        this.__setCache = this.__setCache.bind(this);
    }
    /**
     * Sets the proxy cache value for a given key. Primarily used as a hook for testing.
     * @param key
     * @param value
     */
    ProgramModel.prototype.__setCache = function (key, value) {
        this.__proxyRef[key] = value;
    };
    Object.defineProperty(ProgramModel.prototype, "programViewId", {
        /**
         * DEPRECATED Legacy api - these fields are in place to enable smooth migration from honeycomb resources
         */
        get: function () {
            return this.__state.programViewId || this.__proxyRef.programId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programName", {
        get: function () {
            return get(this.__state, 'program.name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programId", {
        get: function () {
            return get(this.__state, 'program.programId');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "endDate", {
        get: function () {
            return get(this.__state, 'program.endDate') || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "startDate", {
        get: function () {
            return get(this.__state, 'program.startDate') || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "goalSelectionToDate", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "goalSelectionFromDate", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programType", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programLogo", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "heroImageUrl", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "role", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programViewStatus", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "objectiveSummary", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programCalculationType", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "bonusPrecision", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "bonusRoundingMethod", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "goalRoundingMethod", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isMinimumQualifierEnabled", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isBonusEnabled", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isOwnerEligibleForAward", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "goalPrecision", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "mqPrecision", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "mqRoundingMethod", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "paxGoalId", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "groupId", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "timePeriodId", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isObjectives", {
        get: function () {
            // return this.__state.programType === PT__OBJ;
            // TODO: All programs are objectives for now, we need to figure out what that means in the future
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isManager", {
        get: function () {
            // return !selectorRoleRegex.test( this.__state.role );
            // TODO: All programs are objectives for now, we need to figure out what that means in the future
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isGoalSelection", {
        get: function () {
            // return this.__state.programViewStatus === PVS__GOAL_SELECTION;
            // TODO: All programs are objectives for now, no goal selection period
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "hasGoalSelectedAndInGoalSelectionPeriod", {
        get: function () {
            // return this.__state.programViewStatus === PVS__GOAL_SELECTED;
            // TODO: All programs are objectives for now, no goal selection period
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isFinalResults", {
        get: function () {
            return this.__proxyRef.programViewStatus === contests_constants_1.PVS__FINAL_ISSUANCE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "hasProgress", {
        get: function () {
            // Just assume we have progress if the program has started
            return !!get(this.__state, 'progress.0') && this.__proxyRef.programHasStarted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "missedGoalSelection", {
        get: function () {
            return this.__proxyRef.programViewStatus === contests_constants_1.PVS__NO_GOAL_SELECTED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programHasEnded", {
        get: function () {
            return is_after_1.default(new Date(), parse_1.default(this.__proxyRef.endDate || Date.now()));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "programHasStarted", {
        get: function () {
            return is_after_1.default(new Date(), parse_1.default(this.__proxyRef.startDate || Date.now()));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "goalSelectionPeriodHasEnded", {
        get: function () {
            return is_after_1.default(new Date(), parse_1.default(this.__proxyRef.goalSelectionToDate || Date.now()));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isCheckingResults", {
        get: function () {
            return this.__proxyRef.programViewStatus === contests_constants_1.PVS__PROGRESS_LOADED_NO_ISSUANCE && this.__proxyRef.programHasEnded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isWaitingForProgress", {
        get: function () {
            return this.__proxyRef.programViewStatus === contests_constants_1.PVS__NO_PROGRESS && this.__proxyRef.programHasStarted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "daysToGoalSelection", {
        /**
         * Days until the end of the goal selection period
         */
        get: function () {
            return daysToDate(this.__proxyRef.goalSelectionToDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "daysToProgramStartDate", {
        get: function () {
            return daysToDate(this.__proxyRef.startDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "daysToProgramEndDate", {
        get: function () {
            return daysToDate(this.__proxyRef.endDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "totalProgramDays", {
        get: function () {
            return daysToDate(this.__proxyRef.endDate, this.__proxyRef.startDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "daysLeft", {
        /**
         * daysLeft will return a number representing the days left until the next major program state change
         * Days until program selection ending, days until program start, days until program end
         */
        get: function () {
            if (this.__proxyRef.canSelectGoal) {
                return this.__proxyRef.daysToGoalSelection;
            }
            else if (!this.__proxyRef.programHasStarted) {
                return this.__proxyRef.daysToProgramStartDate;
            }
            return this.__proxyRef.daysToProgramEndDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "lastDayLeftDate", {
        /**
         * lastDayLeft date will return a contextual date of the next major program state change
         * Days until program selection ending, days until program start, days until program end
         */
        get: function () {
            if (this.__proxyRef.canSelectGoal) {
                return this.__proxyRef.goalSelectionToDate || Date.now();
            }
            else if (!this.__proxyRef.programHasStarted) {
                return this.__proxyRef.startDate || Date.now();
            }
            return this.__proxyRef.endDate || Date.now();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ProgramModel.prototype, "isStandardCalculationType", {
        /**
         * DEPRECATED:
         * The computed property has been moved to the progress model -> 'ProgressModel.isStandard'
         */
        get: function () {
            console.warn("DEPRECATED METHOD CALL: The computed property has been moved to the progress model -> 'ProgressModel.isStandard'");
            var calcType = this.__proxyRef.programCalculationType || contests_constants_1.CALC_STANDARD;
            return calcType === contests_constants_1.CALC_STANDARD;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isAverageCalculationType", {
        /**
         * DEPRECATED:
         * The computed property has been moved to the progress model -> 'ProgressModel.isAverage'
         */
        get: function () {
            console.warn("DEPRECATED METHOD CALL: The computed property has been moved to the progress model -> 'ProgressModel.isAverage'");
            var calcType = this.__proxyRef.programCalculationType || contests_constants_1.CALC_STANDARD;
            return calcType === contests_constants_1.CALC_AVERAGE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "isReductionCalculationType", {
        /**
         * DEPRECATED:
         * The computed property has been moved to the progress model -> 'ProgressModel.isReduction'
         */
        get: function () {
            console.warn("DEPRECATED METHOD CALL: The computed property has been moved to the progress model -> 'ProgressModel.isReduction'");
            var calcType = this.__proxyRef.programCalculationType || contests_constants_1.CALC_STANDARD;
            return calcType === contests_constants_1.CALC_REDUCTION;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "canCalculateResultsToAchieve", {
        /**
         * DEPRECATED:
         * The computed property has been marked for removal
         */
        get: function () {
            console.warn("DEPRECATED METHOD CALL: The computed property has been marked for removal");
            return !this.__proxyRef.isFinalResults && !!this.__proxyRef.isStandardCalculationType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgramModel.prototype, "canSelectGoal", {
        get: function () {
            return !this.__proxyRef.isObjectives && !this.__proxyRef.goalSelectionPeriodHasEnded;
        },
        enumerable: true,
        configurable: true
    });
    return ProgramModel;
}());
exports.ProgramModel = ProgramModel;
var createProgramModel = function (program) {
    var CACHE = {};
    var computedProgram = new ProgramModel(program);
    var computedProto = computedProgram.constructor.prototype;
    var programModel = new Proxy(computedProgram.__state, {
        get: function (target, key) {
            if (key === '__state') {
                return computedProgram.__state;
            }
            if (key in CACHE) {
                return CACHE[key];
            }
            CACHE[key] = key in computedProto ? computedProgram[key] : target[key];
            return CACHE[key];
        },
        set: function (target, key, value) {
            CACHE[key] = value;
            return true;
        }
    });
    computedProgram.__proxyRef = programModel;
    return programModel;
};
exports.default = createProgramModel;
//# sourceMappingURL=program-model.js.map